export var MfaMethod;
(function (MfaMethod) {
    MfaMethod["MFA_METHOD_UNKNOWN"] = "MFA_METHOD_UNKNOWN";
    MfaMethod["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    MfaMethod["SMS"] = "SMS";
    MfaMethod["PHONE_CALL"] = "PHONE_CALL";
})(MfaMethod || (MfaMethod = {}));
